import React, { useContext } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Text, Flex, Image, Navbar } from './';
import { GlobalContext } from '../context';
import { theme } from '../style';

import clubswan from '../assets/images/Clubswan.svg';

const Appbar = styled.header`
  position: fixed;
  width: 100%;
  background-color: rgba(255, 255, 255);
  box-shadow: rgb(0 0 0 / 11%) 0px 1px 0px;
  z-index: 10000;

  @supports (backdrop-filter: none) {
    background-color: rgba(255, 255, 255, 0.8);

    ::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      backdrop-filter: blur(16px);
      z-index: -1;
    }
  }
`;

const Container = styled(Flex)`
  max-width: ${theme.breakpoints.lg};
  width: 100%;
  height: 80px;
  padding: 0 40px;
  margin: 0 auto;

  @media ${theme.devices.sm} {
    padding: 0 20px;
  }

  .brand {
    text-decoration: none;

    .brandText {
      @media ${theme.devices.md} {
        display: none;
      }
    }
  }
`;

const Header = () => {
  const { language } = useContext(GlobalContext) || {};

  return (
    <Appbar>
      <Container alignItems="center">
        <Link to={language === 'en' ? `/` : `/${language}/`} className="brand">
          <Flex alignItems="center">
            <Image
              src={clubswan}
              alt="Clubswan"
              loading="lazy"
              width="auto"
              height="48px"
            />
            <Text
              as="h3"
              color="black"
              fontWeight="bold"
              ml={3}
              className="brandText"
            >
              Club Swan
            </Text>
          </Flex>
        </Link>

        <Navbar />
      </Container>
    </Appbar>
  );
};

export default Header;
